<script setup>
/* Imports */
import { onBeforeMount } from 'vue';

/* Store */
import { useGlobalStore } from './store/global.js';
import { usePricingStore } from './store/pricing.js';

/* Components */
import FlashMessages from './components/FlashMessages.vue';

/* Init store */
const globalStore = useGlobalStore();
const pricingStore = usePricingStore();

/* Set initial state */
globalStore.setInitialState();

/* Lifecycle Hooks */
onBeforeMount(async () => {
  await pricingStore.fetchPrices();
});

/**
 * When the user removes a compare product, we remove it from the page and from the query parameters
 * If the user clicks on the back button, the query param they removed is added back to the URL
 * but the product that was removed is not added back to the page.
 * To update the state based on the current query params when pressing backward/forward in the browser navigation controls,
 * a full page reload is needed on the popstate event (backward/forward navigation in the compare app)
 */
window.onpopstate = () => {
  window.location.reload();
};
</script>

<template>
  <div
    id="app"
    class="app"
  >
    <g-global-styles />
    <FlashMessages />
    <router-view v-slot="{ Component }">
      <transition
        name="fade-view"
        mode="out-in"
      >
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<style lang="scss" scoped>
#app {
  min-height: 83vh;
}
</style>
